<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.2 1.2H2.51429V2.51429H1.2V1.2ZM1.2 3.34286H2.51429V4.65714H1.2V3.34286ZM1.2 5.48571H2.51429V6.8H1.2V5.48571ZM3.34286 1.2H4.65714V2.51429H3.34286V1.2ZM3.34286 3.34286H4.65714V4.65714H3.34286V3.34286ZM3.34286 5.48571H4.65714V6.8H3.34286V5.48571ZM5.48571 1.2H6.8V2.51429H5.48571V1.2ZM5.48571 3.34286H6.8V4.65714H5.48571V3.34286ZM5.48571 5.48571H6.8V6.8H5.48571V5.48571Z"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linejoin="round"
    />
  </svg>
</template>
